import { modalOpenPdfPageflip } from "..";
import { purify } from "../../_src/components/purify";

export function searchAndloadMoreEbooks() {
    var btnLoadMore = document.querySelector("[data-action=load-more-ebooks]")

    function loadMoreEbooks(loadMore) {
        var form = document.querySelector('#filter-ebooks');
        var data = new FormData(form);

        btnLoadMore ? btnLoadMore.classList.add("loading") : ''

        document.querySelectorAll("#filter-ebooks fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        if (!loadMore) {
            document.querySelector("#result-ebooks").innerHTML = "";
            document.querySelector(".loader-materiais-ebooks").classList.remove("hidden")
        }

        var pagina = loadMore ? btnLoadMore.getAttribute("data-page") : 1;

        fetch(`/acervo-digital/materiais-para-download/ajax/ebooks/p${pagina}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-ebooks").insertAdjacentHTML('beforebegin', response);

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.totalpages)) {
                    btnLoadMore.remove()
                }

            } else {
                document.querySelector("#result-ebooks").innerHTML = purify(response);

                searchAndloadMoreEbooks();
            }

        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {

            if (!loadMore) {
                document.querySelector(".loader-materiais-ebooks").classList.add("hidden")
            }

            modalOpenPdfPageflip();

            btnLoadMore ? btnLoadMore.classList.remove("loading") : ''

            document.querySelectorAll("#filter-ebooks fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })

        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { loadMoreEbooks(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-ebooks").addEventListener("change", function(event) { event.preventDefault(), setTimeout(() => { loadMoreEbooks(false) }, 100),btnLoadMore ? btnLoadMore.dataset.page = "1" : "1" }, false);
}


if (document.querySelector("#filter-ebooks")) {
    searchAndloadMoreEbooks();
}


export function searchAndloadMoreDownloads() {
    var btnLoadMore = document.querySelector("[data-action=load-more-downloads]")

    function loadMore(loadMore) {
        var form = document.querySelector('#filter-downloads');
        var data = new FormData(form);

        btnLoadMore ? btnLoadMore.classList.add("loading") : ''

        document.querySelectorAll("#filter-downloads fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        if (!loadMore) {
            document.querySelector("#result-downloads").innerHTML = "";
            document.querySelector(".loader-materiais-downloads").classList.remove("hidden")
        }

        var pagina = loadMore ? btnLoadMore.getAttribute("data-page") : 1;

        fetch(`/acervo-digital/materiais-para-download/ajax/downloads/p${pagina}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-downloads").insertAdjacentHTML('beforebegin', response);

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.totalpages)) {
                    btnLoadMore.remove()
                }

            } else {
                document.querySelector("#result-downloads").innerHTML = purify(response);

                searchAndloadMoreDownloads();
            }

        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {

            if (!loadMore) {
                document.querySelector(".loader-materiais-downloads").classList.add("hidden")
            }

            btnLoadMore ? btnLoadMore.classList.remove("loading") : ''

            document.querySelectorAll("#filter-downloads fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })

        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { loadMore(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-downloads").addEventListener("change", function(event) { event.preventDefault(), setTimeout(() => { loadMore(false) }, 100),btnLoadMore ? btnLoadMore.dataset.page = "1" : "1" }, false);
}


if (document.querySelector("#filter-downloads")) {
    searchAndloadMoreDownloads();
}
